// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { foodSessionId } from './FoodSession';
import { fileStorageId } from './FileStorage';
import { operatorId } from './Operator';
import { invProductId } from './InvProduct';
import { z } from 'zod';
export const foodRecipeId = (z.number());
export const foodRecipe = z.object({
    id: foodRecipeId,
    session_id: foodSessionId,
    code: z.string(),
    batch_size: z.number().nullable(),
    serving_size: z.number().nullable(),
    rationale: z.string().nullable(),
    feedback: z.string().nullable(),
    base_recipe_id: foodRecipeId.nullable(),
    feedback_image_file_id: fileStorageId.nullable(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
    created_at: z.date(),
    updated_at: z.date(),
    deleted_at: z.date().nullable(),
    deleted_by: operatorId.nullable(),
    converted_product_id: invProductId.nullable(),
    without_farmless_protein: z.boolean(),
});
export const foodRecipeInitializer = z.object({
    id: foodRecipeId.optional(),
    session_id: foodSessionId,
    code: z.string(),
    batch_size: z.number().optional().nullable(),
    serving_size: z.number().optional().nullable(),
    rationale: z.string().optional().nullable(),
    feedback: z.string().optional().nullable(),
    base_recipe_id: foodRecipeId.optional().nullable(),
    feedback_image_file_id: fileStorageId.optional().nullable(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
    converted_product_id: invProductId.optional().nullable(),
    without_farmless_protein: z.boolean().optional(),
});
export const foodRecipeMutator = z.object({
    id: foodRecipeId.optional(),
    session_id: foodSessionId.optional(),
    code: z.string().optional(),
    batch_size: z.number().optional().nullable(),
    serving_size: z.number().optional().nullable(),
    rationale: z.string().optional().nullable(),
    feedback: z.string().optional().nullable(),
    base_recipe_id: foodRecipeId.optional().nullable(),
    feedback_image_file_id: fileStorageId.optional().nullable(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
    converted_product_id: invProductId.optional().nullable(),
    without_farmless_protein: z.boolean().optional(),
});
//# sourceMappingURL=FoodRecipe.js.map